import { inject_style } from "__style_helper__"
inject_style(".__floater__open{filter:none}.__floater__arrow{display:none}")